export default "__VITE_ASSET__1d9ebd29__"